<template>
    <div class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h4 class="modal-title">
                {{ t("Clients Invitation") }}
                <small>{{ t("Configure the invitation for your clients.") }}</small>
              </h4>
            <button class="close" type="button" data-dismiss="modal" aria-hidden="true"><span class="s7-close"></span></button>
          </div>
          <div class="modal-body">
            <div class="card">
                <div class="card-body">
                    <form>
                        <div class="form-group row">
                            <div class="col-12">
                              <div class="input-header">
                                <div class="title">{{ t("Your company name") }}</div>
                              </div>
                              <input class="form-control" type="text" placeholder="Name" v-model="user.name" autocomplete="off">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12">
                                <div class="input-header">
                                  <div class="title">{{ t("Subject") }}</div>
                                </div>
                                <input class="form-control" type="text" v-model="templates.invitation.subject">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12">
                                <div class="input-header">
                                  <div class="title">{{ t("Message") }}</div>
                                </div>
                                <editor id="invitation-editor" class="form-control template-message" :init="tinymce" v-model="templates.invitation.message"></editor>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
          </div>
            <div class="modal-footer">
                <button class="btn btn-link btn-space btn-link-primary full" type="button" data-dismiss="modal">{{ t("create my invitation") }}</button>
                <small>{{ t("Maprinter will invite your clients on your behalf.") }}</small>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import "@/assets/plugins/tinymce/skins/lightgray/skin.min.css";
import "@/assets/plugins/tinymce/skins/lightgray/content.min.css";

var tinymce = require('tinymce/tinymce');
require('tinymce/themes/modern/theme');
import Editor from "@tinymce/tinymce-vue";

require("tinymce/plugins/fullscreen");
require("@/assets/plugins/tinymce/plugins/variable.js");

import { mapState } from "vuex";
export default {
  data() {
    return {
      tinymce: {
        skin: false,
        branding: false,
        menubar: false,
        statusbar: false,
        plugins: "fullscreen, variables",
        variable_mapper: {
          client_name: "Client Name",
          download_link: "Download Link",
          company_name: "Company Name"
        },
        setup: function(editor) {
          editor.addButton('variables', {
            type: 'listbox',
            text: 'Variables',
            icon: false,
            onselect: function (e) {
              editor.plugins.variables.addVariable(this.value());
            },
            values: [
              { text: 'Client Name', value: 'client_name' },
              { text: 'Download Link', value: 'download_link' },
              { text: 'Company Name', value: 'company_name' }
            ]
          });
        },
        toolbar1: "fullscreen | undo redo | variables",
        height: "200",
        forced_root_block : '',
        content_style: ".mce-content-body {font-family:sans-serif;}.variable{cursor:default;background-color:#099bc3;color:#FFF;padding:3px;border-radius:3px;display:inline-block;font-weight:bold;font-style:normal;font-size:12px;line-height:12px;}"
      },
      templates: {
        invitation: {}
      }
    };
  },
  computed: {
    ...mapState({
      user: state => state.user.data,
      ref: state => state.user.ref
    })
  },
  watch: {
    user: function(user) {
      var _this = this;
      if (user.templates && user.templates.invitation) {
        _this.templates.invitation = user.templates.invitation;
      } else {
        _this.templates.invitation = {
          subject: _this.t(`Accurate meter readings for your printers`),
          message: _this.t(`Dear {{client_name}},<br/>
<br/>
We invite you to install a software to show accurate meter readings for your printers.<br/>
<br/>
{{download_link}}<br/>
<br/>
Thank you for your cooperation,<br/>
{{company_name}}`)
        };
      }
    }
  },
  mounted() {
    var _this = this;
    var $invitation = $("#invitation");
    var $form = $invitation.find("form");
    var $primaryBtn = $invitation.find(".btn-link-primary");
  
    $invitation.on('shown.bs.modal', function() {
      tinymce.execCommand('mceFocus',false,'invitation-editor');
    });

    $primaryBtn.click(function() {
      if (_this.user.name.length < 1) {
        alert(_this.t("Pleas enter your company name"));
        return false;
      }

      if (_this.templates.invitation.subject.length < 1) {
        alert(_this.t("Pleas enter a subject"));
        return false;
      }

      if (!_this.templates.invitation.message.includes("{{download_link}}")) {
        alert(_this.t("The message must contains the download variable."));
        return false;
      }

      _this.ref
        .set(
          {
            name: _this.user.name,
            templates: _this.templates
          },
          { merge: true }
        )
        .then(function() {
          $invitation.modal("hide");
        });

      return false;
    });
  },
  components: {
    editor: Editor
  }
};
</script>

<style lang="scss">
#app {
  .modal {
    padding-left: 0 !important;
    .modal-dialog {
      .modal-content {
        .modal-header {
          .modal-title {
            & > small {
              display: block;
              font-size: 12px;
            }
          }
        }
        .modal-body {
          padding-top: 0;
          padding-bottom: 0;
          .card-body {
            padding-top: 0;
          }
          .mce-content-body {
            background-color: #099bc3;
            color: #FFF;
          }
          .input-header {
            .title {
                line-height: 30px;
            }
          }
          .form-group {
            &.dobule-input {
              & > div {
                font-size: 0;
                .input-group {
                  display: inline-block;
                  width: 50%;
                  &.customSmtpServer {
                    font-size: 12px;
                    vertical-align: top;
                    & > label {
                      margin-right: 10px;
                      &:first-child {
                        margin-right: 5px;
                      }
                    }
                  }
                  & > .form-control {
                    width: 100%;
                  }
                }
              }
              &.sender {
                small {
                  font-size: 10px;
                  padding-left: 10px;
                }
              }
            }
            label {
              padding-top: 2px;
              padding-bottom: 5px;
            }
          }
        }
        .modal-footer {
          small {
            width: 100%;
            color: #a0a0a0;
            font-size: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Invitation.vue